<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('changelog_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-math-log</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-changelog-show">
      <v-row>
        <v-col md="3" v-if="item">
          <ImageView :item="item" filter="250x250" :edit="false" />
        </v-col>
      <v-col md="9">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('version.changelog.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

            </tr>

            <tr>
              <td><strong>{{ $t('version.changelog.type') }}</strong></td>
              <td>
                                    {{ item['type'] }}
              </td>

              <td><strong>{{ $t('version.changelog.typevalue') }}</strong></td>
              <td>
                          {{ item['valueType'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('version.changelog.newfeatures') }}</strong></td>
              <td>
                <span  class="tablehtmleditor" v-html="item['newFeatures']"></span>
              </td>

              <td><strong>{{ $t('version.changelog.bugfixes') }}</strong></td>
              <td>
                <span  class="tablehtmleditor" v-html="item['bugFixes']"></span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('version.changelog.knownbugs') }}</strong></td>
              <td>
                <span  class="tablehtmleditor" v-html="item['knownBugs']"></span>
              </td>

              <td><strong>{{ $t('version.changelog.notes') }}</strong></td>
              <td>
                <span  class="tablehtmleditor" v-html="item['notes']"></span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('version.changelog.developexternal') }}</strong></td>
              <td>
                                    {{ item['developExternal'] }}
              </td>

              <td><strong>{{ $t('version.changelog.developer') }}</strong></td>
              <td>
                        <span v-if="item['developer']">{{ item['developer'].login }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('version.changelog.start') }}</strong></td>
              <td>
                        {{ formatDate(item['start'], 'long') }}
              </td>

              <td><strong>{{ $t('version.changelog.end') }}</strong></td>
              <td>
                          {{ formatDate(item['end'], 'long') }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
      <template>
        <div class="link-list">
          <Toolbar/>

          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12>
                <h1>{{$t('version.link.links')}}</h1>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <LinkFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>

                <br />

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
        :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
                  @click:row="showHandlerSubEvent"
                >

                      <ActionCell
                      slot="item.action"
                      slot-scope="props"
                      :handle-show="() => showHandlerSub(item,'Link',props.item)"
                      ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import LinkFilterForm from '../../components/link/Filter';
import DataFilter from '../../components/DataFilter';
import ImageView from '../../components/ImageView.vue';

const servicePrefix = 'ChangeLog';

export default {
  name: 'ChangeLogShow',
  servicePrefix,
  components: {
    Loading,
    Toolbar,
    ActionCell,
    LinkFilterForm,
    DataFilter,
    ImageView
  },
  data() {
    return {
      headers: [
        { text: this.$t('version.link.name'), value: 'name' },
        { text: this.$t('version.link.url'), value: 'url' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'changeLog' : this.$route.params.id,
      },
      selected: []
    };
  },
  mixins: [ListMixin,ShowMixin,AccessMixin],
  computed: {
    ...mapFields('changelog', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('changelog', ['find']),
    ...mapGetters('link', {
      items: 'list'
    }),
    ...mapFields('link', {
      isLoading: 'isLoading'
    }),
    ...mapFields('link', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('changelog', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    }),
    ...mapActions('link', {
      getPage: 'fetchAll',
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'Link',value);
    }
  }
};
</script>
